import React from 'react';
import { Box } from '@mui/material';

export const ButtonPlaceholder = ({ icon }: { icon?: React.ReactNode }) => {
    return <Box sx={{ borderRadius: 100, width: 64, height: 64, border: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</Box>;
};
